/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamDto } from './TeamDto';
import {
    TeamDtoFromJSON,
    TeamDtoFromJSONTyped,
    TeamDtoToJSON,
} from './TeamDto';

/**
 * 
 * @export
 * @interface TeamsDto
 */
export interface TeamsDto {
    /**
     * The teams.
     * @type {Array<TeamDto>}
     * @memberof TeamsDto
     */
    items: Array<TeamDto>;
}

/**
 * Check if a given object implements the TeamsDto interface.
 */
export function instanceOfTeamsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function TeamsDtoFromJSON(json: any): TeamsDto {
    return TeamsDtoFromJSONTyped(json, false);
}

export function TeamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TeamDtoFromJSON)),
    };
}

export function TeamsDtoToJSON(value?: TeamsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(TeamDtoToJSON)),
    };
}

